import PlatformLoader, { LoaderProps as PlatformLoaderProps } from '@platform-ui/loader';
import React from 'react';

type LoaderProps = Omit<PlatformLoaderProps, 'color'>;

interface CustomLoaderProps extends LoaderProps {
  customColor?: string;
  overlayWithoutBackground?: boolean;
}

const Loader: React.FC<CustomLoaderProps> = props => {
  const loaderStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return props.overlayWithoutBackground ? (
    <div style={loaderStyle}>
      <PlatformLoader {...props} color={props.customColor} />
    </div>
  ) : (
    <PlatformLoader {...props} color={props.customColor} />
  );
};

export default Loader;
